import { AUTH_URL } from 'apiUrls';

const DEV_HEADERS: Record<string, string> =
  process.env.NEXT_PUBLIC_DEV_SECRET && !AUTH_URL?.includes('localhost')
    ? { 'Dev-Secret': process.env.NEXT_PUBLIC_DEV_SECRET }
    : {};

export const DEFAULT_HEADERS: Record<string, string> = {
  ...DEV_HEADERS,
  Accept: 'application/json',
  'Content-Type': 'application/json',
  'x-panel': process.env.NEXT_PUBLIC_PANEL || '',
};
type ClientHintNavigator = Navigator & {
  userAgentData?: {
    getHighEntropyValues: (hints: Array<'platform' | 'platformVersion' | 'model'>) => Promise<{
      platform: string;
      platformVersion: string;
      model: string;
    }>;
  };
};
// Check for `window`, not `navigator`: Node 21+ defines a global `navigator`, so a
// `navigator` check passes during SSR and `window` access then throws.
const clientHintNavigator =
  typeof window !== 'undefined' ? (window.navigator as ClientHintNavigator) : undefined;
if (clientHintNavigator && clientHintNavigator.userAgentData) {
  clientHintNavigator.userAgentData
    .getHighEntropyValues(['platform', 'platformVersion', 'model'])
    .then((values) => {
      DEFAULT_HEADERS['X-Os-Name'] = values.platform;
      DEFAULT_HEADERS['X-Os-Version'] = values.platformVersion;
      DEFAULT_HEADERS['X-Model'] = values.model;
    })
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.warn('Error fetching user agent client hints:', error);
    });
}
